import React, { useState, useEffect } from "react";
import Select from "react-select";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { updateLeaveEmployee ,updateShortLeave,
  updateDutyLeave,
  updateSpecialLeave,
  updateMaternityLeave,} from "../../../service/leavesEmployeeApiService";
import { getAllLeaveTypes } from "../../../service/leaveApiServices/leaveTypesApi";
import { getAllEmployeesMethod } from "../../../service/ApiServices";

const EditLeaveEmployee = ({ handleCancel, selectedEmployeeLeave }) => {
  const leaveDayOptions = [
    { value: "Choose Status", label: "Choose Status" },
    { value: "FULL DAY", label: "Full Day", dayValue: 1 },
    { value: "FIRST HALF", label: "First Half", dayValue: 0.5 },
    { value: "SECOND HALF", label: "Second Half", dayValue: 0.5 },
  ];

  const shortLeaveOptions = [
    { value: "Clock In", label: "Clock In" },
    { value: "Clock Out", label: "Clock Out" },
  ];

  const [dateRange, setDateRange] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);
  const [reason, setReason] = useState("");
  const [leaveDays, setLeaveDays] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [shortLeave, setShortLeave] = useState(false);
  const [dutyLeave, setDutyLeave] = useState(false);
  const [specialLeave, setSpecialLeave] = useState(false);
  const [regularLeave, setRegularLeave] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedCoverupEmployee, setSelectedCoverupEmployee] = useState(null);
  const [status, setStatus] = useState("PENDING");
  const [comments, setComments] = useState("");
  const [documentFile, setDocumentFile] = useState(null); // New state for document file
  const [maternityLeave, setMaternityLeave] = useState(false);
const [selectedExpectedDeliveryDate, setSelectedExpectedDeliveryDate] = useState(null);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      try {
        const leaveTypeRecord = await getAllLeaveTypes({
          search: "",
          setLoading: () => {},
        });

        if (leaveTypeRecord) {
          const options = leaveTypeRecord.map((leave) => ({
            value: leave._id,
            label: leave.name,
            leaveCount: leave.minimumLeaveCount,
          }));
          setLeaveType([{ value: "Choose", label: "Choose" }, ...options]);
        }
      } catch (error) {
        console.error("Error fetching leave types:", error);
      }
    };

    const fetchEmployees = async () => {
      try {
        await getAllEmployeesMethod({
          setEmployeeData: setEmployees,
          setLoading: () => {},
          params: { page: 1, limit: 1000 },
          search: "",
        });
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchLeaveTypes();
    fetchEmployees();
  }, []);

useEffect(() => {
  if (selectedEmployeeLeave) {
    setSelectedStartDate(dayjs(selectedEmployeeLeave.startDate).toDate());
    setSelectedEndDate(dayjs(selectedEmployeeLeave.endDate).toDate());
    setReason(selectedEmployeeLeave.reason || "");
    setStatus(selectedEmployeeLeave.status || "PENDING");
    setComments(selectedEmployeeLeave.comments || "");

    // Reset all leave type flags
    setRegularLeave(false);
    setShortLeave(false);
    setDutyLeave(false);
    setSpecialLeave(false);
    setMaternityLeave(false);

    // Identify leave type
    if (selectedEmployeeLeave.leavetype) {
      setSelectedLeaveType({
        value: selectedEmployeeLeave.leavetype._id,
        label: selectedEmployeeLeave.leavetype.name,
      });
      setRegularLeave(true);
    } else if (selectedEmployeeLeave.leave_time) { // Short Leave
      setShortLeave(true);
      setSelectedTime(
        shortLeaveOptions.find(
          (option) => option.value === selectedEmployeeLeave.leave_time
        ) || null
      );
    } else if (selectedEmployeeLeave.dutyLeave) {
      setDutyLeave(true);
    } else if (selectedEmployeeLeave.specialLeave) {
      setSpecialLeave(true);
    } else if (selectedEmployeeLeave.expectedDeliveryDate) { // Maternity Leave
      setMaternityLeave(true);
      setSelectedExpectedDeliveryDate(
        selectedEmployeeLeave.expectedDeliveryDate
          ? dayjs(selectedEmployeeLeave.expectedDeliveryDate).toDate()
          : null
      );
    }

    if (selectedEmployeeLeave.coverupEmployee) {
      setSelectedCoverupEmployee({
        value: selectedEmployeeLeave.coverupEmployee._id,
        label:
          selectedEmployeeLeave.coverupEmployee.full_name ||
          `${selectedEmployeeLeave.coverupEmployee.first_name} ${selectedEmployeeLeave.coverupEmployee.last_name}`,
      });
    }

    // Populate leaveDays
    const daysArray = [];
    let dayCount = 1;
    let currentDate = new Date(selectedEmployeeLeave.startDate);
    const endDate = new Date(selectedEmployeeLeave.endDate);

    while (currentDate <= endDate) {
      const leaveDay = selectedEmployeeLeave.leaveDays?.find(
        (day) => day.date === formatDate(new Date(currentDate))
      );
      daysArray.push({
        day: `Day ${dayCount}`,
        date: formatDate(new Date(currentDate)),
        leaveType: leaveDay?.Day || selectedEmployeeLeave.attendanceType || null,
        dayValue: leaveDay
          ? leaveDayOptions.find((opt) => opt.value === leaveDay.Day)?.dayValue
          : selectedEmployeeLeave.attendanceType
          ? leaveDayOptions.find((opt) => opt.value === selectedEmployeeLeave.attendanceType)?.dayValue
          : null,
      });
      currentDate.setDate(currentDate.getDate() + 1);
      dayCount++;
    }
    setDateRange(daysArray);
    setLeaveDays(daysArray);

    if (selectedEmployeeLeave.document) {
      // Existing document handling
    }
  }
}, [selectedEmployeeLeave]);

  const formatDate = (date) => {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const handleDateRangeChange = (dates) => {
    if (!dates) {
      setSelectedStartDate(null);
      setSelectedEndDate(null);
      setDateRange([]);
      setLeaveDays([]);
      return;
    }

    const [start, end] = dates;
    setSelectedStartDate(start.toDate());
    setSelectedEndDate(end.toDate());

    // Generate date range
    const daysArray = [];
    let dayCount = 1;
    let currentDate = new Date(start);
    const endDate = new Date(end);

    while (currentDate <= endDate) {
      daysArray.push({
        day: `Day ${dayCount}`,
        date: formatDate(new Date(currentDate)),
        leaveType: null,
        dayValue: null,
      });
      currentDate.setDate(currentDate.getDate() + 1);
      dayCount++;
    }
    setDateRange(daysArray);
    setLeaveDays(daysArray);
  };

  const handleLeaveTypeChange = (index, selectedOption) => {
    const updatedLeaveDays = [...leaveDays];
    updatedLeaveDays[index].leaveType = selectedOption.value;
    updatedLeaveDays[index].dayValue = selectedOption.dayValue;
    setLeaveDays(updatedLeaveDays);
  };

  const calculateTotalLeaveDays = () => {
    return leaveDays.reduce((total, day) => total + (day.dayValue || 0), 0);
  };

  // Handle document file change
  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Optional: Validate file type and size
      const validTypes = ["application/pdf", "image/jpeg", "image/png"];
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (!validTypes.includes(file.type)) {
        Swal.fire({
          icon: "warning",
          title: "Invalid File Type",
          text: "Only PDF, JPEG, and PNG files are allowed.",
        });
        setDocumentFile(null);
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          icon: "warning",
          title: "File Too Large",
          text: "File size must be less than 5MB.",
        });
        setDocumentFile(null);
        return;
      }
      setDocumentFile(file);
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validation logic (unchanged)
  if (!selectedStartDate || !selectedEndDate) {
    Swal.fire({
      icon: "warning",
      title: "Required Fields Missing",
      text: "Please select both start and end dates.",
    });
    return;
  }

  if (
    regularLeave &&
    (!selectedLeaveType || leaveDays.some((day) => !day.leaveType))
  ) {
    Swal.fire({
      icon: "warning",
      title: "Required Fields Missing",
      text: "Please select a leave type and specify leave days for all selected dates.",
    });
    return;
  }

  if (shortLeave && !selectedTime) {
    Swal.fire({
      icon: "warning",
      title: "Required Fields Missing",
      text: "Please select a leave time for short leave.",
    });
    return;
  }

  if ((dutyLeave || specialLeave) && !reason) {
    Swal.fire({
      icon: "fail",
      title: "Required",
      text: "Please provide a reason for duty or special leave.",
    });
    return;
  }

  if (maternityLeave && !selectedExpectedDeliveryDate) {
    Swal.fire({
      icon: "warning",
      title: "Required Fields Missing",
      text: "Please select an expected delivery date for maternity leave.",
    });
    return;
  }

  const totalLeaveDays = calculateTotalLeaveDays();

  if (
    regularLeave &&
    selectedLeaveType &&
    totalLeaveDays > selectedLeaveType.leaveCount
  ) {
    Swal.fire({
      icon: "warning",
      title: "Invalid Leave Count",
      text: "The total leave count cannot exceed the available leave balance.",
    });
    return;
  }

const leaveDetails = {
    employeeId: selectedEmployeeLeave.employee?._id || null,
    leaveDays: leaveDays.map((day) => ({
      date: day.date,
      Day: day.leaveType,
    })),
    reason: reason || null,
    startDate: formatDate(selectedStartDate),
    endDate: formatDate(selectedEndDate),
    approval: null,
    coverupEmployee: selectedCoverupEmployee?.value || null,
    duration: totalLeaveDays || 1,
    status: status || "PENDING",
    comments: comments || null,
    document: documentFile || selectedEmployeeLeave.document || null,
  };


if (regularLeave) {
    leaveDetails.leavetype = selectedLeaveType?.value;
  } else if (shortLeave) {
    leaveDetails.shortLeaveTime = selectedTime?.value || null;
  } else if (maternityLeave) {
    leaveDetails.expectedDeliveryDate = selectedExpectedDeliveryDate
      ? formatDate(selectedExpectedDeliveryDate)
      : null;
  }


 try {
    let response;
    if (regularLeave) {
      response = await updateLeaveEmployee(
        selectedEmployeeLeave._id,
        leaveDetails,
        documentFile
      );
    } else if (shortLeave) {
      response = await updateShortLeave(
        selectedEmployeeLeave._id,
        leaveDetails,
        documentFile
      );
    } else if (dutyLeave) {
      console.log("Calling updateDutyLeave with:", {
        leaveId: selectedEmployeeLeave._id,
        leaveDetails,
        hasDocument: !!documentFile,
      });
      response = await updateDutyLeave(
        selectedEmployeeLeave._id,
        leaveDetails,
        documentFile
      );
    } else if (specialLeave) {
      response = await updateSpecialLeave(
        selectedEmployeeLeave._id,
        leaveDetails,
        documentFile
      );
    } else if (maternityLeave) {
      response = await updateMaternityLeave(
        selectedEmployeeLeave._id,
        leaveDetails,
        documentFile
      );
    }

    console.log(`API Response for ${leaveType}:`, {
      response,
      leaveType,
      leaveId: selectedEmployeeLeave._id,
    });
    // Debug: Log response details
   

    // Check if response is valid
    if (!response) {
      throw new Error("No response received from the server");
    }

    // Check response structure
    if (typeof response !== "object" || !response.status) {
      console.warn("Invalid response structure:", response);
      throw new Error("Invalid response structure from server");
    }

    if (response.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Leave Updated",
        text: "Leave has been updated successfully!",
      }).then(() => {
        handleCancel();
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: response.message || "Failed to update leave. Please try again.",
      });
    }
  } catch (error) {
    console.error("Failed to update Employee Leave:", {
      error: error.message,
      stack: error.stack,
      leaveType: "dutyLeave",
      leaveId: selectedEmployeeLeave._id,
    });
    Swal.fire({
      icon: "error",
      title: "Error",
      text:
        error.response?.data?.message ||
        error.message ||
        "Failed to update Employee Leave. Please try again.",
    });
  }
};
  return (
    <div>
      <div className="modal-content">
        <div className="page-wrapper-new p-0">
          <div className="content">
            <div className="modal-header border-0 custom-modal-header">
              <div className="page-title">
                <h4>Edit Leave</h4>
              </div>
            </div>
            <div className="modal-body custom-modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="mb-3">
                    <div
                      className="button-container-app"
                      style={{ display: "none" }}
                    >
                      <div
                        className={`tag-leave ${regularLeave ? "active" : ""}`}
                        onClick={() => {
                          setRegularLeave(true);
                          setShortLeave(false);
                          setDutyLeave(false);
                          setSpecialLeave(false);
                        }}
                      >F
                        Regular
                      </div>
                      <div
                        className={`tag-leave ${shortLeave ? "active" : ""}`}
                        onClick={() => {
                          setRegularLeave(false);
                          setShortLeave(true);
                          setDutyLeave(false);
                          setSpecialLeave(false);
                        }}
                      >
                        Short
                      </div>
                      <div
                        className={`tag-leave ${dutyLeave ? "active" : ""}`}
                        onClick={() => {
                          setRegularLeave(false);
                          setShortLeave(false);
                          setDutyLeave(true);
                          setSpecialLeave(false);
                        }}
                      >
                        Duty
                      </div>
                      <div
                        className={`tag-leave ${specialLeave ? "active" : ""}`}
                        onClick={() => {
                          setRegularLeave(false);
                          setShortLeave(false);
                          setDutyLeave(false);
                          setSpecialLeave(true);
                        }}
                      >
                        Special
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="input-blocks">
                      <label>Date Range</label>
                      <div className="input-groupicon calender-input">
                        <RangePicker
                          value={
                            selectedStartDate && selectedEndDate
                              ? [
                                  dayjs(selectedStartDate),
                                  dayjs(selectedEndDate),
                                ]
                              : null
                          }
                          onChange={handleDateRangeChange}
                          className="filterdatepicker"
                          format="DD-MM-YYYY"
                          placeholder={["Start Date", "End Date"]}
                          style={{ width: "100%", height: "40px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {regularLeave && (
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Select Leave Type</label>
                        <Select
                          className="select"
                          options={leaveType}
                          value={selectedLeaveType}
                          onChange={setSelectedLeaveType}
                          placeholder="Select Leave Type"
                        />
                      </div>
                    </div>
                  )}

                  {shortLeave && (
                    <div className="col-lg-12">
                      <div className="mb-3">
                        <label className="form-label">Leave Time</label>
                        <Select
                          className="select"
                          options={shortLeaveOptions}
                          value={selectedTime}
                          onChange={setSelectedTime}
                          placeholder="Select Time"
                        />
                      </div>
                    </div>
                  )}
{maternityLeave && (
  <div className="col-lg-12">
    <div className="mb-3">
      <label className="form-label">Expected Delivery Date</label>
      <DatePicker
        value={selectedExpectedDeliveryDate ? dayjs(selectedExpectedDeliveryDate) : null}
        onChange={(date) => setSelectedExpectedDeliveryDate(date ? date.toDate() : null)}
        className="filterdatepicker"
        format="DD-MM-YYYY"
        placeholder="Select Expected Delivery Date"
        style={{ width: "100%", height: "40px" }}
      />
    </div>
  </div>
)}
                  {dateRange.map((item, index) => (
                    <div key={index} className="col-lg-12">
                      <div className="apply-leave">
                        <div className="leave-apply">
                          <div className="leave-date">
                            <span>{item.day}</span>
                            <p>{item.date}</p>
                          </div>
                          <div className="leave-time">
                            <div className="input-blocks mb-0">
                              <Select
                                className="select"
                                options={leaveDayOptions}
                                value={leaveDayOptions.find(
                                  (option) => option.value === item.leaveType
                                )}
                                onChange={(selectedOption) =>
                                  handleLeaveTypeChange(index, selectedOption)
                                }
                                placeholder="Select Leave Day"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">Cover-up Employee</label>
                      <Select
                        className="select"
                        options={
                          employees.data?.map((emp) => ({
                            value: emp._id,
                            label:
                              emp.full_name ||
                              `${emp.first_name} ${emp.last_name}`,
                          })) || []
                        }
                        value={selectedCoverupEmployee}
                        onChange={setSelectedCoverupEmployee}
                        placeholder="Select Cover-up Employee"
                        isClearable
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="mb-3 summer-description-box mb-0">
                      <label className="form-label">Reason</label>
                      <input
                        type="text"
                        className="form-control"
                        value={reason}
                        onChange={(event) => setReason(event.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="mb-3 summer-description-box mb-0">
                      <label className="form-label">Status</label>
                      <Select
                        className="select"
                        options={[
                          { value: "PENDING", label: "Pending" },
                          { value: "APPROVED", label: "Approved" },
                          { value: "REJECTED", label: "Rejected" },
                        ]}
                        value={{ value: status, label: status }}
                        onChange={(option) => setStatus(option.value)}
                        placeholder="Select Status"
                        isDisabled={true}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="mb-3 summer-description-box mb-0">
                      <label className="form-label">Comments</label>
                      <input
                        type="text"
                        className="form-control"
                        value={comments}
                        onChange={(event) => setComments(event.target.value)}
                      />
                    </div>
                  </div>

                  {/* New Document Upload Field */}
                  <div className="col-lg-12">
                    <div className="mb-3 summer-description-box mb-0">
                      <label className="form-label">
                        Upload Supporting Document (Optional)
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={handleDocumentChange}
                      />
                      {documentFile && (
                        <p className="mt-2">
                          Selected file: {documentFile.name}
                        </p>
                      )}
                      {selectedEmployeeLeave.document && !documentFile && (
                        <p className="mt-2">
                          Existing document:{" "}
                          <a
                            href={selectedEmployeeLeave.document}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Document
                          </a>
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="modal-footer-btn">
                  <button
                    type="button"
                    className="btn btn-cancel me-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

EditLeaveEmployee.propTypes = {
  selectedEmployeeLeave: PropTypes.object.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default EditLeaveEmployee;
